<template>
    <div class="JingxuanWrap">
        <div class="header">
            <Heads isBack="true">
                <slot>
                    <h2>乐铺精选</h2>
                </slot>
            </Heads>
        </div>
        <div class="jingxuan_scroll" style="overflow: scroll;-webkit-overflow-scrolling: touch;" ref="wrapper" :style="{ height: (wrapperHeight) + 'px' }">
            <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" ref="loadmore" :autoFill="isAutoFill">
                <div class="jingxuan_banner">
                    <img src="//assets.lepucdn.cn/mtest/images/shop/list_banner.jpg" />
                </div>
                <div class="jingxuan_text">
                    <div class="jingxuan_list" v-for="(val,ind) in shopDes" :key="ind">
                        <h2>{{val.title}}</h2>
                        <p>{{val.desc}}</p>
                    </div>
                </div>
                <div :class="['jingxuan_screen']" ref="Screen">
                    <div :class="[posActive?'screenActive':'']">
                        <Screen v-on:listenScreen="listenScreen" v-on:screenClick="screenClick" :setScreenFlag="setScreenFlag" :config="configDatas"></Screen>
                    </div>
                </div>
                <div class="jingxuan_listCon" :class="[posActive?'paddingActive':'']">
                    <div class="jingxuan_item" v-for="(val,ind) in shopList" :key="ind" @click="goDetail(val)">
                        <div class="itemImg">
                            <img :src="val.main_img+'@!middle.jpg'" alt="">
                            <p>{{val.utitle}}</p>
                            <i v-if="val.has_video!=1" class="iconfont icon-shipin"></i>
                        </div>
                        <div class="itemTip" v-if="val.autotag">
                            <div class="itemTip_autotag" v-for="(text,ind) in val.autotag" :key="ind">
                                <span v-for="(textinner,ind) in text" :key="ind">{{textinner}}</span>
                            </div>
                        </div>
                        <div class="itemMsg">
                            <span><i class="iconfont icon-zuobiaofill"></i>{{val.street}}</span>
                            <span>￥<b>{{val.money[0]}}{{val.money[1]}}</b></span>
                        </div>
                        <div class="item_shoper">
                            <div class="item_shoper_msg">
                                <dl>
                                    <dt>
                                        <img :src="val.staff_photo" alt="">
                                    </dt>
                                    <dd>
                                        <h3>{{val.staff_name}}<span>{{val.hepu_name}}</span></h3>
                                        <p>{{val.hepu_last_time}} 现场核铺</p>
                                    </dd>
                                </dl>
                                <a :href="'tel:'+val.staff_phone"><i class="iconfont icon-help-tel"></i></a>
                            </div>
                            <h4>商铺亮点：</h4>
                            <p>{{val.ctitle}}</p>
                            <h5>更多详情信息 ></h5>
                        </div>
                    </div>
                </div>
            </mt-loadmore>
        </div>  
        <Loading v-if="isLoading" fixedNum="notop"></Loading>
    </div>
</template>
<script>
import Heads from "@/components/heads.vue"
import Screen from "@/components/Shop/screen.vue"
import Loading from "@/components/Loading.vue"
export default {
    name: "Jingxuan",
    data(){
        return{
            shopDes: [],
            shopList: [],
            page:1,
            hasmore: null, //是否有下一页
            allLoaded:false,
            isAutoFill:false,
            wrapperHeight: 0,
            isRefresh: false,
            flag:false,
            screenData:{
                area: undefined,
                districts: undefined,
                shop_area: undefined, 
                start_area: undefined,
                end_area: undefined,
                money: undefined,
                cost_range: undefined,
                start_money: undefined,
                end_money: undefined,
                start_cost: undefined,
                end_cost: undefined
            },
            lastData: {},
            posActive: false, //控制Screen定位
            setScreenFlag: 1, //父传子设置开关
            city_en: 'beijing',
            configDatas: null,
            isLoading: false,
            
        }
    },
    components:{
        Heads,
        Screen,
        Loading
    },
    methods: {
        // 获取数据
        getData(){
            this.isLoading = true
            var url = `//api.lepu.cn/app/shop/self-shop-list?page=${this.page}`
            var str = ''
            this.lastData = []
            Object.keys(this.screenData).forEach(key => {
                if(this.screenData[key]!=undefined&&this.screenData[key]!=''&&this.screenData[key]!=null){
                    this.lastData[key] = this.screenData[key]
                }
            });
            Object.keys(this.lastData).forEach(key=>{
                str+=`&${key}=${this.lastData[key]}`
            })
            this.ajax.get(url+str).then(res=>{
                var res = res.data
                this.isLoading = false
                if(res.status == 1){
                    this.shopDes = res.data.self_shop_des
                    this.shopList = this.shopList.concat(res.data.list)
                    this.hasmore = res.data.hasmore
                    this.isRefresh = true
                    this.city_en = res.data.city_en
                }else{
                    this.$toast({
                        message: res.note,
                        position: 'middle',
                        duration: 2000
                    })
                }
            })
        },
        // 获取config数据
        getStreetData(){
            this.ajax.get('//api.lepu.cn/app/shop/config').then(res=>{
                var res = res.data
                // this.isLoading = true
                if(res.data.code==1){
                    this.configDatas = res.data.config
                }
            })
        },
        // 监听子组件
        listenScreen(data){
            // console.log(data)
            this.screenData = data
            this.shopList = []
            this.getData()
        },
        // 监听点击事件
        screenClick(data){
            // console.log(document.getElementById("Screen").getBoundingClientRect().top)
            // this.$nextTick(()=>{
            //     // this.$refs.Screen.scrollBy(0,300)
            // })
            // console.log(data)
            if(data){
                this.$refs.Screen.scrollIntoView(true)                
            }else{
                this.$refs.Screen.scrollIntoView(false)                
            }
        },
         // 上拉加载
        loadBottom: function(){
            if(this.hasmore == 1){
                this.page ++
                this.isLoading = false
                this.getData()
            }else{
                this.$toast({
                    message: '没有更多了~',
                    position: 'middle',
                    duration: 2000
                })
            }
            this.$refs.loadmore.onBottomLoaded();
        },
        // 下拉刷新
        loadTop() {
            this.setScreenFlag ++
            this.page = 1
            this.shopDes = []
            this.shopList = []
            this.screenData = {
                area: undefined,
                districts: undefined,
                shop_area: undefined, 
                start_area: undefined,
                end_area: undefined,
                money: undefined,
                cost_range: undefined,
                start_money: undefined,
                end_money: undefined,
                start_cost: undefined,
                end_cost: undefined
            },
            this.isLoading = true
            this.getData()
            if(this.isRefresh){
                this.$refs.loadmore.onTopLoaded();
                // this.isRefresh = false
            }
        },
        // 获取Screen到顶部的距离
        handleScroll(el){
            let _pos = Math.ceil(this.$refs.Screen.getBoundingClientRect().top)
            if(_pos<=50){
                this.posActive = true
            }else{
                this.posActive = false
            }
            // console.log(_pos)
        },
        // 跳转详情页
        goDetail(val){
            location.href = `//m.lepu.cn/${this.city_en}/shop/detail-${val.id}`
        }
    },
    created(){
        this.getData()
        this.getStreetData()
    },
    updated(){
        if(this.$refs.wrapper!=undefined){
            this.wrapperHeight =
            document.documentElement.clientHeight -
            this.$refs.wrapper.getBoundingClientRect().top
        }  
        return
    },
    mounted(){
        window.addEventListener('scroll',this.handleScroll,true)
    }
}
</script>
<style lang="scss" scoped>
.JingxuanWrap{
    width:100%;
    background: #f6f6f6;
}

.screenActive{
    position: fixed;
    top: .88rem;
    left: 0;
    right: 0;
    z-index: 2;
}

.paddingActive{
    margin-top: 1rem;
}

.header{
    width:100%;
}

.jingxuan_banner{
    width: 100%;
    
    img{
        width: 100%;
    }
}

.jingxuan_text{
    width: 100%;
    display: flex;
    padding: .15rem .25rem;
    box-sizing: border-box;
    justify-content: space-between;
    flex-wrap: wrap;

    .jingxuan_list{
        width: 49%;
        margin-bottom: .1rem;
        background: #fff;
        padding: .1rem;
        box-sizing: border-box;

        &>h2{
            font-size: .28rem;
            height: .6rem;
            line-height: .6rem;
        }

        &>p{
            font-size: .2rem;
            color: #666;
            line-height: .3rem;
        }
    }
}

.jingxuan_listCon{
    width: 100%;
    padding: .3rem .3rem 0;
    box-sizing: border-box;

    .jingxuan_item{
        background: #fff;
        border-radius: .1rem;
        overflow: hidden;
        margin-bottom: .2rem;

        .itemImg{
            width: 100%;
            height: 3.5rem;
            padding: .4rem .3rem 0;
            box-sizing: border-box;
            position: relative;

            img{
                width: 100%;
                height: 100%;
            }

            &>p{
                position: absolute;
                bottom: 0;
                left:.3rem;
                right: .3rem;
                height: .6rem;
                background: rgba(0,0,0,.5);
                color: #fff;
                line-height: .6rem;
                padding-left: .1rem;
                font-size: .26rem;
                box-sizing: border-box;
            }

            &>i{
                position: absolute;
                top: 50%;
                left: 50%;
                font-size: .8rem;
                color: #fff;
                margin-top: -.35rem;
                margin-left: -.25rem;
            }
        }

        .itemTip{
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            padding: .2rem .3rem 0;
            box-sizing: border-box;

            .itemTip_autotag{
                margin-bottom: .1rem;
            }

            span{
                display: inline-block;
                background: #f5f5f5;
                color: #666;
                font-size: .22rem;
                padding: .02rem .04rem;
                margin-right: .1rem;
                margin-bottom: .1rem;
            }
        }

        .itemMsg{
            width: 100%;
            padding: 0 .3rem .2rem;
            height: .6rem;
            margin-top: .2rem;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            border-bottom: 0.01rem solid #eee;
            justify-content: space-between;

            span{
                color: #666;

                &>i{
                    color: #999;
                    font-size: .24rem;
                    margin-right: .06rem;
                }

                &:nth-child(2){
                    color: #de4b4f;
                    
                    b{
                        font-size: .3rem;
                        font-weight: normal;
                    }
                }
            }
        }

        .item_shoper{
            width: 100%;
            padding: 0 .3rem .2rem;
            box-sizing: border-box;

            .item_shoper_msg{
                width: 100%;
                display: flex;
                padding-top: .3rem;
                box-sizing: border-box;
                align-items: center;
                justify-content: space-between;

                dl{
                    flex: 1;
                    display: flex;
                    align-items: center;

                    dt{
                        width: .7rem;
                        height: .7rem;
                        border-radius: 50%;
                        overflow: hidden;
                        margin-right: .1rem;

                        img{
                            width: 100%;
                            height: 100%;
                        }
                    }

                    dd{
                        width: 100%;

                        &>h3{
                            height: .46rem;
                            font-size: .28rem;
                            line-height: .46rem;

                            span{
                                font-size: .24rem;
                                color: #999;
                                margin-left: .1rem;
                            }
                        }

                        p{
                            line-height: .44rem;
                            font-size: .24rem;
                            color: #999;
                        }
                    }
                }

                i{
                    font-size: .4rem;
                    color: #de4b4f;
                }
            }

            &>h4{
                width: 100%;
                height: 0.24rem;
                line-height: 0.24rem;
                font-size: 0.24rem;
                margin-top: 0.32rem;
                margin-bottom: 0.2rem;
                overflow: hidden;
                color: #de4b4f;
            }

            &>p{
                line-height: 0.36rem;
                font-size: 0.24rem;
                color: #666;
                overflow: hidden;
                // max-height: 1.44rem;
            }

            &>h5{
                width: 100%;
                line-height: .6rem;
                text-align: right;
                font-size: .24rem;
                color: #999;
            }
        }
    }
}
</style>